import { downloadFile } from '../services/files';

export const handleDownloadFiles = (reviewId: number) => async (attachmentIds: string[]) => {
  for (const attachmentId of attachmentIds) {
    const { file, fileName } = await downloadFile({ reviewId, fileId: attachmentId });

    let url = window.URL.createObjectURL(new Blob([file]));
    let a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }
};
